    import { Directive, ElementRef, HostListener, Input } from '@angular/core';

    @Directive({
      selector: 'img[appImageFallback]', // Apply to <img> elements with the appImageFallback attribute
      standalone: true
    })
    export class ImageFallbackDirective {
      @Input('appImageFallback') fallbackSrc: string = 'assets/images/reports/Custom.png'; // Default fallback image

      constructor(private el: ElementRef<HTMLImageElement>) {}

      @HostListener('error')
      onError(): void {
        this.el.nativeElement.src = this.fallbackSrc;
      }
    }